<template>
  <v-dialog
    v-model="show"
    width="640"
  >
    <v-card
      class="dialogBackground"
      :disabled="loading"
    >
      <v-row
        no-gutters
        class="dialogTitleBackground white--text px-2 py-1 mb-2"
        align="center"
      >
        <span>Количество товара</span>
        <v-spacer />
        <v-btn
          small
          icon
          dark
          @click="cancelClick"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-row>

      <v-card-text v-if="detail.id">
        <v-row
          align="center"
          justify="center"
          no-gutters
          class="mx-0"
        >
          <v-col cols="3 pl-0 pr-1">
            <v-text-field
              v-model="detail.goodArticle"
              width="100"
              autocomplete="off"
              type="text"
              label="Артикул"
              readonly
              hide-details
            />
          </v-col>
          <v-col cols="9 pl-1 pr-0">
            <v-text-field
              v-model="detail.goodName"
              autocomplete="off"
              type="text"
              label="Наименование"
              readonly
              hide-details
            />
          </v-col>

          <v-col cols="6 pl-0 pr-1">
            <v-text-field
              v-model="detail.qty"
              autocomplete="off"
              type="number"
              label="Количество (упаковок)"
              :error-messages="objectErrors($v.detail.qty)"
              @input="$v.detail.qty.$touch()"
              @blur="$v.detail.qty.$touch()"
              @focus="$event.target.select()"
            />
          </v-col>

          <v-col cols="6 pl-1 pr-0">
            <!-- Номер партии всегда -->
            <v-text-field
              v-if="detail.usePartNumber"
              v-model="detail.partNumber"
              autocomplete="off"
              type="text"
              label="Номер партии"
              :counter="$v.detail.partNumber.$params.maxLength.max"
              :error-messages="objectErrors($v.detail.partNumber)"
              @input="$v.detail.partNumber.$touch()"
              @blur="$v.detail.partNumber.$touch()"
            />
            <!-- Дата производства при расходе -->
            <DateInput
              v-else-if="detail.requestTypeID == 2"
              v-model="detail.productionDate"
              label="Дата производства"
              resetable
            />
          </v-col>
        </v-row>

        <v-col class="px-0">
          <div class="d-flex justify-space-between flex-row">
            <span>Поддонов {{ palletCnt }}</span>
            <span>На поддоне {{ packageOnPallet }} уп.</span>
            <span>В упаковке {{ detail.qiPackage }} шт.</span>
            <span>На поддоне {{ detail.qiPallet }} шт.</span>
          </div>
        </v-col>
      </v-card-text>

      <v-card-actions class="pt-8">
        <v-spacer />
        <v-btn
          class="px-6"
          outlined
          @click.prevent="cancelClick"
        >
          Отмена
        </v-btn>
        <v-btn
          class="px-4"
          color="primary"
          :loading="loading"
          @click.prevent="okClick"
        >
          Сохранить
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import DateInput from "@/components/DateInput"
import { required, maxLength, minValue, integer } from "vuelidate/lib/validators"

export default {
  components: {
    DateInput
  },

  props: {
    value: { 
      type: Object, 
      default: null 
    },
    saveCallback: { 
      type: Function, 
      required: true 
    }
  },

  data() {
    return {
      detail: {
        id: 0,
        goodArticle: '',
        goodName: '',
        qty: 0,
        partNumber: '',
        productionDate: null,
        qiPackage: 1,
        qiPallet: 1,
        usePartNumber: true,
        requestTypeID: 1
      },
      loading: false
    }
  },

  computed: {
    show: {
      get() {
        return !!this.detail.id
      },
      set(val) {
        if (!val) {
          this.$v.$reset()
          this.$emit("input", null)
        }
      }
    },

    packageOnPallet() {
      if (!this.detail.qiPackage || !this.detail.qiPallet) return 0
      return Math.floor(this.detail.qiPallet / this.detail.qiPackage)
    },

    palletCnt() {
      if (!this.detail.qty || !this.packageOnPallet) return 0
      return Math.ceil(this.detail.qty / this.packageOnPallet)
    }
  },

  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          // Инициализируем данные из переданного объекта
          this.detail = {
            id: newVal.id || -1,
            goodID: newVal.goodID || 0,
            goodArticle: newVal.goodArticle || '',
            goodName: newVal.goodName || '',
            qty: newVal.qty || 0,
            partNumber: newVal.partNumber || '',
            productionDate: newVal.productionDate || null,
            qiPackage: newVal.qiPackage || 1,
            qiPallet: newVal.qiPallet || 1,
            usePartNumber: newVal.usePartNumber !== undefined ? newVal.usePartNumber : true,
            requestTypeID: newVal.requestTypeID || 1
          }
          // Сбрасываем валидацию при открытии
          this.$nextTick(() => {
            this.$v.$reset()
          })
        } else {
          // Сбрасываем при закрытии
          this.detail = {
            id: 0,
            goodID: 0,
            goodArticle: '',
            goodName: '',
            qty: 0,
            partNumber: '',
            productionDate: null,
            qiPackage: 1,
            qiPallet: 1,
            usePartNumber: true,
            requestTypeID: 1
          }
        }
      }
    }
  },

  validations() {
    return {
      detail: {
        partNumber: { maxLength: maxLength(40) },
        qty: { required, integer, minValue: minValue(1) }
      }
    }
  },

  methods: {
    objectErrors(obj) {
      if (!obj || !obj.$dirty) return []
      const errors = []

      if (obj.$params.integer && !obj.integer) {
        errors.push("Введите целое число")
      }

      if (obj.$params.minValue && !obj.minValue) {
        errors.push(`Значение должно быть больше ${obj.$params.minValue.min}`)
      }

      if (obj.$params.maxLength && !obj.maxLength) {
        errors.push(`Не более ${obj.$params.maxLength.max} символов, пожалуйста`)
      }

      if (obj.$params.required && !obj.required) {
        errors.push("Введите значение")
      }

      return errors
    },

    async okClick() {
      this.$v.$touch()
      
      if (this.$v.$invalid) {
        return
      }
      
      try {
        this.loading = true
        
        const result = await this.saveCallback({
          ...this.detail,
          partNumber: this.detail.partNumber?.trim() ?? "",
          productionDate: this.detail.productionDate 
            ? this.detail.productionDate.substring(0, 10) 
            : null,
          qty: parseInt(this.detail.qty)
        })
        
        if (result !== false) {
          this.show = false
        }
      } catch (error) {
        console.error('Ошибка при сохранении:', error)
      } finally {
        this.loading = false
      }
    },

    cancelClick() {
      this.show = false
    }
  }
}
</script>